import { animate, group, query, sequence, state, style, transition, trigger } from '@angular/animations';

//TODO: change the name of this animation.
export const slideInOutAnimation = trigger('slideInOut', [
  transition('closed <=> *', [
    query(':enter .drawer', style({ transform: 'translateX(100%)' }), { optional: true }),
    query(':leave .drawer', style({ transform: 'translateX(0%)' }), { optional: true }),
    sequence([
      query(':leave .drawer', [
        animate('0.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(100%)' }))
      ], { optional: true }),
      query(':enter .drawer', [
        animate('0.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(0%)' }))
      ], { optional: true })
    ])
  ]),
  transition('* => *', [
    query(':enter .drawer > :not(app-drawer-close-button)', style({ opacity: 0 }), { optional: true }),
    query(':leave .drawer > :not(app-drawer-close-button)', [
      style({ opacity: 1 }),
      animate('0.2s', style({ opacity: 0 }))
    ], { optional: true }),
    query(':enter .drawer > :not(app-drawer-close-button)', [
      style({ opacity: 0 }),
      animate('0.2s', style({ opacity: 1 }))
    ], { optional: true })
  ])
]);


export const expandCollapseAnimation = trigger('expandCollapse', [
  transition(':enter', [
    style({ height: '0', opacity: 0 }),

    group([
      animate(300, style({ height: '*' })),
      animate('400ms ease-in-out', style({ 'opacity': '1' }))
    ])
  ]),
  transition(':leave', [
    style({ height: '*', opacity: 1 }),

    group([
      animate(300, style({ height: 0 })),
      animate('200ms ease-in-out', style({ 'opacity': '0' }))
    ])
  ])
]);

export const fadeInOut = trigger('fadeInOut', [
  transition('in => out', [
    animate('400ms ease-in-out', style({ 'opacity': '0' }))
  ]),
  transition('out => in', [
    animate('400ms ease-in-out', style({ 'opacity': '1' }))
  ]),
]);
